import { useSelector } from 'react-redux';
import { ComponentLoader } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import ExceptionFeedbackBySelector from '@app/components/common/Exception/ExceptionFeedbackBySelector';
import MyEquipmentFilter from '@app/components/common/MyEquipmentFilter';
import ProductListSpecificationsContainer from '../ProductListSpecificationsContainer';
import ProductListItemsCount from '@app/components/common/ProductListItemsCount';
import ProductListCategoryMenu from '@app/components/common/ProductListCategoryMenu';
import { PAGE_BREAKPOINTS, STATUS } from '@app/constants/commonConstants';
import styles from '../styles.module.scss';
import { useBreakpoint } from '@app/hooks';

const ProductListSidebar = ({ handleEquipmentCheck, pageDoesntExist }) => {
  const currentCategory = useSelector(s => s.plpUI.current);
  const filterByEquipment = useSelector(s => s.plpUI.filterByEquipment);
  const isFacetsLoading = useSelector(s => s.plpUI.isFacetsLoading);
  const plpDetailsStatus = useSelector(s => s.plpUI.getPlpDetailsStatus);
  const equipmentList = useSelector(
    s => s.myEquipment.equipments.myEquipmentList || []
  );
  const catalogEntries = useSelector(
    state => state.categories.byId[currentCategory]?.productsId
  );
  const recordSetTotal = useSelector(
    state => state.categories.byId[currentCategory]?.productCount
  );
  const model = useSelector(
    s => s.myEquipment.equipments.selectedEquipment?.model
  );
  const serialNumber = useSelector(
    s => s.myEquipment.equipments.selectedEquipment?.serialNumber
  );
  const subcategories = useSelector(
    s => s.categories.byId[currentCategory]?.subcategories
  );
  const subCategoryTitle = useSelector(
    s => s.categories.byId[currentCategory]?.name
  );

  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  const shouldShowSidebarLoader =
    isMD && plpDetailsStatus === STATUS.PENDING && isFacetsLoading;

  return (
    <div
      className="col-12 px-0 d-flex flex-column col-md-3"
      data-testid="sidebarContainer"
    >
      <div className="order-1 order-md-0 mt-sm-4">
        <MyEquipmentFilter
          equipmentList={equipmentList}
          recordSetTotal={recordSetTotal}
          model={model}
          serialNumber={serialNumber}
          checked={filterByEquipment}
          pageDoesntExist={pageDoesntExist}
          onCheck={handleEquipmentCheck}
        />
      </div>
      <div data-testid="categoryContainer" className="position-relative">
        <ProductListCategoryMenu
          subcategories={subcategories}
          subCategoryTitle={subCategoryTitle}
          showDesktopExpander
          showSubCategorieCaret
        />
        <div className="d-flex justify-content-between align-items-baseline d-md-block mb-2 mb-md-0">
          <div className="d-md-none">
            <ProductListItemsCount
              currentItemsCount={catalogEntries?.length}
              totalItemsCount={recordSetTotal}
            />
          </div>
          <ProductListSpecificationsContainer />
        </div>
        {shouldShowSidebarLoader && (
          <ComponentLoader
            size="small"
            contentClassName={styles['component-loader--sidebar']}
          />
        )}
      </div>
      <ExceptionFeedbackBySelector
        selector={s => s.errors?.[ERROR_DOMAIN.PLP]?.[ERROR_PATH.MAIN]}
        className="mb-4 pb-2 d-md-none"
        showReferenceId
      />
    </div>
  );
};

ProductListSidebar.propTypes = {
  handleEquipmentCheck: PropTypes.func,
  pageDoesntExist: PropTypes.bool
};

export default ProductListSidebar;
